import React from "react";
import { IconButton, Select, SortGeneralIcon } from "@activecollab/components";
import PropTypes from "prop-types";
import i18n from "~/i18n";

const options = [
  { id: "favorites", name: i18n.t("Favorites") },
  { id: "labels", name: i18n.t("Label") },
  { id: "companies", name: i18n.t("Client") },
  { id: "categories", name: i18n.t("Category") },
  { id: "leaders", name: i18n.t("Project Leader") },
];

export const ProjectsPickerGroupBy = ({ selected, onChange, className, ...rest }) => {
  return (
    <Select
      {...rest}
      keepSameOptionsOrder
      disableSearch
      selected={selected}
      onChange={onChange}
      disabledInternalSort
      forceCloseMenu
      options={options}
      target={
        <IconButton
          className={className}
          variant="text gray"
        >
          <SortGeneralIcon />
        </IconButton>
      }
    />
  );
};

ProjectsPickerGroupBy.propTypes = {
  onChange: PropTypes.func,
  selected: PropTypes.string,
  className: PropTypes.string,
};

ProjectsPickerGroupBy.defaultProps = {
  selected: "favorites",
};
